module.exports = __webpack_public_path__ + "img/hu.05eae7f1.svg";